import { render } from "./Game.vue?vue&type=template&id=13a60885&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=13a60885&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13a60885"

export default script